export { default } from './marketing/home';
